import { useState, useEffect } from "react";
import { getCompanyByPathRouteKey } from "../api/CompanyAPI";
import {
  getCompanySubscription,
  SubscriptionInfo,
} from "../api/SubscriptionAPI";

export const useClientSubscriptionExpired = (dynamicPath?: string) => {
  const [isExpired, setIsExpired] = useState(false);
  const [subscriptionInfo, setSubscriptionInfo] =
    useState<SubscriptionInfo | null>(null);
  const [loading, setLoading] = useState(true);

  const checkSubscription = async () => {
    try {
      setLoading(true);

      if (!dynamicPath) {
        setIsExpired(false);
        setLoading(false);
        return;
      }

      const company = await getCompanyByPathRouteKey(dynamicPath);

      if (!company) {
        setIsExpired(false);
        setLoading(false);
        return;
      }

      const info = await getCompanySubscription(Number(company.id));
      setSubscriptionInfo(info);
      if (!info || !info.subscription) {
        setIsExpired(false);
        setLoading(false);
        return;
      }

      const subscription = info.subscription;
      const now = new Date();
      let expired = false;

      switch (subscription.status) {
        case 2:
        case 3:
          expired = true;
          break;

        case 0:
          if (subscription.trialEndsAt) {
            const trialEnd = new Date(subscription.trialEndsAt);
            expired = now > trialEnd;
          }
          break;

        case 1:
          if (subscription.currentPeriodEndsAt) {
            const periodEnd = new Date(subscription.currentPeriodEndsAt);
            expired = now > periodEnd;
          }
          break;
      }

      setIsExpired(expired);
    } catch (error) {
      console.error("Erro ao verificar assinatura:", error);
      setIsExpired(false);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    checkSubscription();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dynamicPath]);

  return {
    isExpired,
    subscriptionInfo,
    loading,
    refresh: checkSubscription,
  };
};
